import React from 'react';
import { classList } from '../../../utils/string.ts';

export type BackdropProps = {
  opacity?: { type: 'fade-in' } | { type: 'fade-out' } | { type: 'fixed'; value: number };
};

/**
 * Lies above all content and visually dampens it.
 * e.g. used for modals and flyouts.
 */
export const Backdrop = React.forwardRef<
  HTMLDivElement,
  BackdropProps & React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
  const { opacity = { type: 'fade-in' }, ...htmlAttributes } = props;

  return (
    <div
      {...htmlAttributes}
      style={
        opacity.type === 'fixed'
          ? { opacity: opacity.value, ...htmlAttributes.style }
          : htmlAttributes.style
      }
      className={classList(
        'bg-sk-grey-900/50 animate-fadeIn fixed inset-0 z-(--z-index-backdrop)',
        htmlAttributes.className
      )}
      ref={ref}
    />
  );
});
